import { Injectable } from "@angular/core";
import { ForeignPageError, PDFDocument, PDFField, bytesFor } from "pdf-lib";
import { Observable } from "rxjs";


@Injectable()
export class FileService {

  constructor() { }

  downloadFile(file: Blob, filename: string): void {
    var ext = filename.substr(filename.lastIndexOf('.') + 1);

    let mimeType = 'application/pdf';
    if (ext == 'jpg' || ext == 'jpeg') mimeType = 'image/jpeg';
    if (ext == 'png') mimeType = 'image/png';

    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    var newBlob = new Blob([file], { type: mimeType });

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
      (window.navigator as any).msSaveOrOpenBlob(newBlob);
      return;
    }

    // For other browsers: 
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(newBlob);

    var link = document.createElement('a');

    // safari doesn't support this yet
    if (typeof link.download === 'undefined') {
      window.location.href = data;
    } else {
      link.href = data;
      link.download = filename;
      link.setAttribute('target', '_self');

      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    }

    setTimeout(function () {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data);
      link.remove();
    }, 100);
  }  

  async downloadMergedFile(files: Blob[], filename: string): Promise<void> {
    var ext = filename.substr(filename.lastIndexOf('.') + 1);

    let mimeType = 'application/pdf';
    if (ext == 'jpg' || ext == 'jpeg') mimeType = 'image/jpeg';
    if (ext == 'png') mimeType = 'image/png';

    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    var mergedBlob = new Blob([], { type: mimeType });
    const mergedPdf = await PDFDocument.create();

    await this.createMergedPDF(files, mergedPdf, mimeType, filename);
  }

  async createMergedPDF(files: any, mergedPdf: PDFDocument, mimeType: string, filename: string) {
    for (const file of files) {
      await mergeFile(file, mergedPdf);
    }      
      
    this.downloadFile(new Blob([await mergedPdf.save()], { type: mimeType }), filename);
  }
}

function mergeFile(file: any, mergedPdf: PDFDocument) {
  return new Promise((resolve) => {
    setTimeout(async () => {
      var fileArrayBuffer = await file.arrayBuffer();

      const pdf = await PDFDocument.load(fileArrayBuffer);
      const copiedPagesA = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
      copiedPagesA.forEach((page) => mergedPdf.addPage(page));
      resolve(mergedPdf);
    }, 500);
  });
}
